export const pageNotFoundRoute = {
    path: '/404',
    component: 'page-not-found',
    componentName: 'Page Not Found',
    theme: 'default',
    template: 'common',
};